export default {"src":"/_next/static/media/external_bold.ec6df198.svg","height":24,"width":24};